import { render, staticRenderFns } from "./TableDanPhong.vue?vue&type=template&id=ba4b2f3e&"
import script from "./TableDanPhong.vue?vue&type=script&lang=js&"
export * from "./TableDanPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports